window.App = require('config/app');

require('config/routes');

require('config/store');

require('routes/IndexRoute');

require('routes/DocumentRoute');

require('routes/DocumentsRoute');

require('routes/DocumentsNewRoute');

require('models/Document');

require('controllers/DocumentController');

require('controllers/DocumentsController');

require('helpers/markdown');

require('helpers/date');

require('templates/application');

require('templates/index');

require('templates/documents');

require('templates/document');
